"use strict";
/** @jsx jsx */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoStyling = exports.topContainerStyling = exports.contentContainerStyling = exports.containerStyling = void 0;
const React = __importStar(require("react"));
const core_1 = require("@emotion/core");
exports.containerStyling = (theme) => {
    return core_1.css `
        padding: 0;
        margin: 0;
    `;
};
exports.contentContainerStyling = (theme) => {
    return core_1.css `
        text-align: center;
        padding-top: 30px;
        max-width: 1300px;
        margin-left: auto;
        margin-right: auto;
    `;
};
exports.topContainerStyling = (theme) => {
    return core_1.css `
        background-color: #007F85;
        width: 100%;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    `;
};
exports.logoStyling = (theme) => {
    return core_1.css `
        display: block;
        margin-left: auto;
        margin-right: auto;
        height: 50px;
    `;
};
class View extends React.Component {
    render() {
        return (core_1.jsx("div", { css: (t) => [exports.containerStyling(t), this.props.containerStyling !== undefined ? this.props.containerStyling(t) : undefined] },
            core_1.jsx("div", { css: exports.topContainerStyling },
                core_1.jsx("img", { css: (t) => [exports.logoStyling(t), this.props.logoStyling !== undefined ? this.props.logoStyling(t) : undefined], src: "/images/logo.png" })),
            core_1.jsx("div", { css: (t) => [exports.contentContainerStyling(t), this.props.contentContainerStyling !== undefined ? this.props.contentContainerStyling(t) : undefined] }, this.props.children)));
    }
}
exports.default = View;
//# sourceMappingURL=View.js.map